import axios from 'axios'

import config from '../../config'

const createWorkOrderType = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/WorkOrderTypes`
  return axios.post(url, data)
}

export default createWorkOrderType
